// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfilesList_container__EGchP","list":"ProfilesList_list__FOmHI","title":"ProfilesList_title__zAYrq"};